import { Config } from '../../src/config';
import { ITrackPayload } from '../../src/track';
import { CXF } from '../../typings/cxf';

export class CxfAdapter {
    private cxfStub: CXF;
    private config: Config;

    constructor(cxfStub: CXF, config: Config) {
        this.cxfStub = cxfStub;
        this.config = config;
    }

    public raiseTrackEvent(): void {
        this.cxfStub.emit(this.config.CXF_TRACK_MSG, {eventId: 1183} as ITrackPayload);
    }
}
